import { Button, Highlights, Stack } from '@cmg/design-system';
import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';

import routeFactory from '../../../common/util/routeFactory';
import { OfferingProfile_LiteQuery } from '../../offering-dl/offering-profile/graphql/__generated__/OfferingProfile';
import { SectorHeader } from '../../offering-dl/offering-profile/profiles/shared/components/SectorHeader';
import { selectUserSettings } from '../../shared/ducks';
import ActionsDropdownButton from './actions-dropdown-button/ActionsDropdownButton';

const mapStateToProps = state => ({
  userSettings: selectUserSettings(state),
});

export type ChildProps = {
  offeringProfile: OfferingProfile_LiteQuery;
  onDeleteButtonClicked: () => void;
  showDropdownActionButton?: boolean;
  onOpenImportDialog: () => void;
};
export type Props = ChildProps & ReturnType<typeof mapStateToProps>;

const ParticipationSubHeader: React.FC<Props> = ({
  offeringProfile,
  userSettings,
  onDeleteButtonClicked,
  showDropdownActionButton,
  onOpenImportDialog,
}) => {
  const { issuer } = offeringProfile.offeringById ?? {};

  const title = issuer?.id ? (
    <NavLink to={routeFactory.companies.getUrlPath({ id: issuer?.id })}>{issuer?.name}</NavLink>
  ) : (
    issuer?.name
  );

  const actions = (
    <React.Fragment>
      <Button onClick={onOpenImportDialog}>Upload Participation</Button>
      {showDropdownActionButton && (
        <ActionsDropdownButton onDeleteButtonClicked={onDeleteButtonClicked} />
      )}
    </React.Fragment>
  );

  return (
    <Highlights
      divider={false}
      title={title}
      subtitle={issuer?.primarySymbol?.toUpperCase()}
      titleItems={
        <Stack columnGap={2} direction="row" flexWrap="wrap" alignSelf="flex-end">
          {issuer && <SectorHeader issuer={issuer} userSettings={userSettings} />}
        </Stack>
      }
      actions={actions}
    />
  );
};

const ParticipationSubHeaderProvider = connect(mapStateToProps)(ParticipationSubHeader);

export default ParticipationSubHeaderProvider;
